import { message } from "antd";
import { EDITOR_ID } from ".";
import { DomainGroupConfig, DomainTreeNodeData, SaveStatusEnum } from "@/pages/documentCompile/type";
import { getOnlyOfficeCallbackStatus, saveOnlyOfficeDoc } from "../api/onlyoffice";

function splitTemplateString(str: string) {
  const regex = /(\$\{[^}]+\})/g;
  return str.split(regex).filter((part) => part !== "");
}

// console.log(splitTemplateString("超过了 1000 ${name}  万"));
// // 输出: [ '超过了 1000 ', '${name}', '  万' ]

// console.log(splitTemplateString("超过了 1000 ${name} ${age}   万"));
// // 输出: [ '超过了 1000 ', '${name}', ' ', '${age}', '   万' ]

// console.log(splitTemplateString("超过了 1000 万"));
// 输出: [ '超过了 1000 万' ]

// 获取嵌套的域配置内容 比如：超过了 1000 万 ${name}
// export const getDomainElements = (text: string) => {
//   const elemens = [] as any[];
//   const parts = splitTemplateString(text);
//   parts.forEach((part) => {
//     if (part.startsWith("${")) {
//       const refFieldId = part.slice(2, -1);
//       const refField = getFieldConfigById(refFieldId);
//       if (refField) {
//         const refControl = Api.CreateInlineLvlSdt();
//         refControl.SetTag(refField.id);
//         refControl.AddText(refField.title);
//       }
//     } else {
//       elemens.push(Api.CreateRun().AddText(part));
//     }
//   });
//   return elemens;
// };

// 检查并更新复选框状态
export function checkAndUpdateCheckboxes() {
  const doc = Api.GetDocument();
  const contentControls = doc.GetAllContentControls();
  // 遍历所有内容控件，找到复选框对
  const processedIds = new Set();
  contentControls.forEach((control: any) => {
    const tag = control.GetTag();
    if (tag.endsWith("_yes") || tag.endsWith("_no")) {
      const id = tag.split("_")[0];
      if (processedIds.has(id)) return; // 避免重复处理同一组复选框
      processedIds.add(id);
      // 找到对应的 yes 和 no 复选框
      const yesControl = contentControls.find(
        (c) => c.GetTag() === `${id}_yes`
      );
      const noControl = contentControls.find((c) => c.GetTag() === `${id}_no`);

      if (yesControl && noControl) {
        const yesChecked = yesControl.Checked;
        const noChecked = noControl.Checked;

        // 互斥逻辑：确保只有一个复选框被选中
        if (yesChecked && noChecked) {
          // 如果两者都被选中，取消 no 的选中状态
          noControl.SetCheckBoxChecked(false);
        } else if (!yesChecked && !noChecked) {
          // 如果两者都未选中，默认选中 no
          noControl.SetCheckBoxChecked(true);
        }

        // 联动内容：更新复选框后的文本
        // updateCheckboxText(id, yesChecked);
      }
    }
  });
}

// 将域配置转换为树节点数据
export const convertToTreeData = (groups: DomainGroupConfig[]): DomainTreeNodeData[] => {
  return groups.map((group) => ({
    key: group.fieldName,
    title: group.fieldName,
    type: "group" as const,
    children: group.fields?.map((field) => ({
      key: field.fieldName,
      title: field.fieldName,
      type: "field" as const,
      fieldConfig: field,
    })),
  }));
};

// 移除域高亮背景
export const handleRemoveHighlight = () => {
  console.log("移除域高亮背景");
  const editor = window.DocEditor?.instances[EDITOR_ID];
  if (editor) {
    const connector = editor.createConnector();
    connector.callCommand(() => {
      console.log("移除域高亮背景");
      let doc = Api.GetDocument();
      let allElements = doc.GetAllContentControls(); // 获取文档中所有内容控件
      for (let i = 0; i < allElements.length; i++) {
        let sdt = allElements[i];
        console.log("sdt", sdt.GetTag());
        // sdt.SetBackgroundColor(255, 255, 255, 0);
        // 解锁
        sdt.SetLock("sdtLocked");
        sdt.SetBackgroundColor(0, 0, 255, 0);

      }
    });
  }
};

// 获取当前 editor
export const getCurrentEditor = () => {
  const editor = window.DocEditor?.instances[EDITOR_ID];
  if (!editor) {
    message.error("编辑器未准备就绪");
    return;
  }
  return editor;
  // return window.connector
};

// 获取当前文档 connector
export const getCurrentConnector = () => {
  // const editor = getCurrentEditor();
  // if (!editor) {
  //   message.error("编辑器未准备就绪");
  //   return;
  // }
  // return editor.createConnector();
  return window.connector
};

// 设置长文本
export const handleSetLongText = () => {
  const editor = getCurrentEditor();
  if (editor) {
    const connector = editor.createConnector();
    connector.callCommand(() => {
      console.log("设置长文本");
      const doc = Api.GetDocument();
      const contentControls = doc.GetCurrentParagraph();
      let inlineLvlSdt = Api.CreateInlineLvlSdt();
      inlineLvlSdt.SetBackgroundColor(255, 255, 0, 100); // 黄色
      inlineLvlSdt.AddText("sadfdsfadsfsfasfdasdfasdfasd 撒旦法多少分多少阿凡达似懂非懂书法大赛地方是的发多少分打撒");
      contentControls.AddElement(inlineLvlSdt);
    });
  }
};

interface PollDocumentStatusOptions {
  fileKey: string;
  interval?: number;         // 轮询间隔，默认 5000 毫秒
  timeout?: number;          // 超时时间，默认 2 分钟
  isUnmountedRef?: React.RefObject<boolean>; // 页面卸载标识
}

export function pollDocumentStatus(options: PollDocumentStatusOptions): Promise<any> {
  const {
    fileKey,
    interval = 5000,
    timeout = 2 * 60 * 1000,
    isUnmountedRef,
  } = options;

  const startTime = Date.now();

  return new Promise((resolve, reject) => {
    const poll = () => {
      if (isUnmountedRef?.current) {
        return reject(new Error('页面已卸载，轮询被取消'));
      }
      getOnlyOfficeCallbackStatus(fileKey)
        .then(res => {
          console.log('轮询结果:', res, '时间:', new Date().toLocaleTimeString());
          if (res?.status === -1) {
            reject(new Error('保存失败，请稍后重试'));
            return;
          }
          if (res?.status === 0) {
            if (Date.now() - startTime >= timeout) {
              reject(new Error('保存超时，请稍后重试'));
            } else {
              setTimeout(poll, interval);
            }
          } else {
            resolve(res);
          }
        })
        .catch(err => reject(err));
    };

    poll(); // 初次立即轮询
  });
}



interface SaveDocumentOptions {
  fileName: string;
  editorConfig: any;
  onSuccess?: (data: { fileUrl: string, modify?: boolean }) => void;
  onError?: (error: any) => void;
  showMessage?: boolean; // 是否显示成功/失败消息
  isUnmountedRef?: React.RefObject<boolean>; // 页面卸载标识
}

interface SaveDocumentResult {
  success: boolean;
  fileUrl?: string;
  error?: any;
  modify?: boolean
}

/**
 * 保存文档的纯函数
 * @param options 保存选项
 * @returns Promise<SaveDocumentResult>
 */
export async function saveDocument(options: SaveDocumentOptions): Promise<SaveDocumentResult> {
  const {
    fileName,
    editorConfig,
    onSuccess,
    onError,
    showMessage = true,
    isUnmountedRef
  } = options;
  try {
    const { key } = editorConfig?.document || {};
    if (!key) {
      throw new Error('未找到文档密钥');
    }

    // 调用保存接口
    const res = await saveOnlyOfficeDoc({ fileKey: key, fileName });
    if (res.code == '420') {
      onSuccess?.({ fileUrl: key, modify: false });
      // 注意 这个 key 这里没用 和 fileUrl 没关系
      return { success: true, fileUrl: key, modify: false };
    }
    // 轮询文档状态
    const getStatusRes = await pollDocumentStatus({ fileKey: key, isUnmountedRef });
    const fileUrl = getStatusRes?.fileUrl;

    if (fileUrl) {
      if (showMessage) {
        message.success('保存成功');
      }

      onSuccess?.({ fileUrl });
      return { success: true, fileUrl, modify: true };
    } 
      throw new Error('保存失败，未获取到文件URL');
    
  } catch (error) {
    const errorMessage = error?.message || '保存失败';

    if (showMessage) {
      message.error(errorMessage);
    }

    onError?.(error);
    return { success: false, error };
  }
}